import { TrashIcon } from '../../components/Icons'

/**
 * „1 Nachricht" / „3 Nachrichten" — die Pluralregel steht an einer Stelle.
 *
 * Dieselbe Machart wie `map/Freigabeleiste.tsx`: eine Funktion, die zaehlt und
 * benennt, statt derselben Regel im JSX. Zweimal hingeschrieben laeuft sie
 * auseinander, und dann steht in der Leiste etwas anderes als in der
 * Rueckfrage.
 */
export function nachrichtenWorte(anzahl: number): string {
  return anzahl === 1 ? '1 Nachricht' : `${anzahl} Nachrichten`
}

/**
 * Die Leiste am Fuss des Verlaufs, solange ausgewaehlt wird (#30).
 *
 * Aus dem Betrieb, nach dem Vorbild von WhatsApp und iMessage: „nach Auswahl
 * von Löschen im Menü: unten öffnet sich eine Leiste mit einem
 * Papierkorb-Symbol."
 *
 * **Sie ersetzt die Eingabezeile, statt sich darueberzulegen.** Zwei Leisten
 * uebereinander nehmen dem Verlauf auf 390 Punkten die halbe Hoehe -- und
 * schreiben kann man ohnehin nicht, waehrend man auswaehlt.
 *
 * **Ohne Netz ist der Papierkorb abgeschaltet, mit Grund.** Ein Loeschauftrag
 * geht nicht in den Ausgangskorb: er traefe Stunden spaeter auf einen
 * Verlauf, der inzwischen ein anderer ist. Also lieber gar nicht als
 * halb -- aber nie stillschweigend.
 */
export function Auswahlleiste({
  anzahl,
  laeuft,
  online,
  onAbbrechen,
  onLoeschen,
}: {
  anzahl: number
  laeuft: boolean
  online: boolean
  onAbbrechen: () => void
  onLoeschen: () => void
}) {
  const gesperrt = anzahl === 0 || laeuft || !online

  return (
    <div className="auswahlleiste" role="toolbar" aria-label="Nachrichten löschen">
      <button type="button" className="button button--outline button--small" onClick={onAbbrechen}>
        Abbrechen
      </button>

      <span className="auswahlleiste__zahl" aria-live="polite">
        {anzahl === 0 ? 'Nichts ausgewählt' : `${nachrichtenWorte(anzahl)} ausgewählt`}
      </span>

      <button
        type="button"
        className="icon-button icon-button--gefahr"
        disabled={gesperrt}
        onClick={onLoeschen}
        aria-label={`${nachrichtenWorte(anzahl)} löschen`}
        title={online ? undefined : 'Ohne Netz geht das gerade nicht.'}
      >
        <TrashIcon size={20} />
      </button>

      {/* **Der Grund steht als Text da, nicht nur als `title`.** Auf dem
          Telefon ist ein Tooltip unsichtbar. */}
      {!online && <p className="auswahlleiste__hinweis">Ohne Netz geht das gerade nicht.</p>}
    </div>
  )
}
